<template>
  <base-tooltip
    :token="token"
    type="info"
    :z-index="999999"
    class="info-tooltip">
    <template #default>
      <span class="tooltip__trigger">?</span>
    </template>
    <template #content>
      <span
        v-if="renderTextAsHtml"
        class="tooltip__content"
        v-html="text" />
      <span
        v-else
        class="tooltip__content">
        {{ text }}
      </span>
    </template>
  </base-tooltip>
</template>

<script>
import BaseTooltip from 'Components/ui/Tooltip/BaseTooltip.vue';
import { uuidv4 } from 'Root/helpers/tools';

export default {
  name: 'InfoTooltip',

  components: {
    BaseTooltip,
  },

  props: {
    text: {
      type: String,
      default: null,
    },

    renderTextAsHtml: {
      type: Boolean,
      default: false,
    },

    token: {
      type: String,
      default: uuidv4(),
    },
  },
};
</script>

<style lang="scss" scoped>
.info-tooltip {
  font-size: $text-13px;
}

.tooltip__trigger {
  color: $color--basic-white;
  font-weight: bold;
  display: inline-block;
  line-height: 1.6em;
  width: 1.6em;
  height: 1.6em;
  text-align: center;
  background-color: $color--basic-blue;
  border-radius: 50%;
  cursor: default;
  font-size: 1em;
}
</style>
